// prompts currently carrying hide:true, shown at /admin/hidden_prompts
import { GET_HIDDEN_PROMPTS, REMOVE_HIDDEN_PROMPT } from '../actions/types';

// an array, not a map: the page sorts it and renders it in order, and there is
// no lookup-by-id access pattern here
const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HIDDEN_PROMPTS:
      // a copy, so a later filter cannot mutate the caller's array
      return [...action.payload.hiddenPrompts];
    case REMOVE_HIDDEN_PROMPT:
      return state.filter(prompt => prompt.id !== action.payload.promptID);
    default:
      return state;
  }
};
